<fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-banner [bannerTitle]="'events.page.title' | translate"></fgb-banner>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container mt-3">
  <fgbcl-marketplace-list
    [isList]="true"
    [marketplaceItemTypes]="[3, 5]"
    [eventItemView]="true"
    [showSortBar]="false"
  ></fgbcl-marketplace-list>
</div>
